import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CustomRegistrationService } from '../../custom-registration.service';

@Component({
  selector: 'app-user-confirmation',
  templateUrl: './user-confirmation.component.html',
  styleUrls: ['./user-confirmation.component.scss'],
})
export class UserConfirmationComponent implements OnInit, OnDestroy {
  message: any;
  userData: any = null;
  creditInvoice: string;
  compName = 'UserRegistrationBannerComponent';
  baseSiteId = '';
  baseSub: Subscription;

  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly baseSite: BaseSiteService,
    private readonly _dataLayerService: DataLayerService,
    private readonly sharedService: SharedService
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.creditInvoice = 'invoiceTable';
    this.userData = JSON.parse(localStorage.getItem('userConfirmationData'));
    this.message = this.userData?.msgData;
    this.baseSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
        const _win: any = window;
        if (
          this.sharedService.getLocalStorage('userName') != '' &&
          this.sharedService.getLocalStorage('userName') != null &&
          this.sharedService.getLocalStorage('userName') != undefined
        ) {
          //GTM
          this._dataLayerService.addtoDataLayer(
            'login',
            this.sharedService.getLocalStorage('userName')
          );
          this._dataLayerService.addtoDataLayer(
            'userReg',
            this.sharedService.getLocalStorage('userName')
          );
          this._dataLayerService.addtoDataLayer(
            'userReg_FormEvent',
            '',
            '',
            '',
            'form_step',
            'confirmation'
          );
          this._dataLayerService.addtoDataLayer(
            'userReg_FormEvent',
            '',
            '',
            '',
            'form_submit',
            'confirmation'
          );
        } else {
          //GTM
          this._dataLayerService.addtoDataLayer(
            'userReg_FormEvent',
            '',
            '',
            '',
            'form_error',
            'confirmation'
          );
        }
      });
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
  }
}
